import {createFeatureSelector, createSelector} from '@ngrx/store';
import {Deserialize} from 'cerialize';
import {CurrentAccountState} from '../states/current-account-state';

export const CurrentAccountSelector = createSelector(createFeatureSelector(CurrentAccountState.key),
  (state: CurrentAccountState): CurrentAccountState => {
    return Deserialize(state, CurrentAccountState);
  });
